import EnrollmentTable from './EnrollmentTable'

export default EnrollmentTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/EnrollmentTable/index.js